/* eslint-disable indent */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Modal,
  ModalFooter,
  MultiColumnList,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { filter, get } from 'lodash';
import { getTranslatedItemStatus } from '@folio/inventory/src/constants';
import { useForm } from 'react-final-form';
import { ClipCopy } from '@folio/stripes/smart-components';
import css from '../../styles.css';

function ConfirmDeleteItemsModal({
  onClose,
  open,
  selectedItems,
  fields,
  holdingsRecordId,
  isFullScreen,
  onRemove,
}) {
  const form = useForm();
  const selectedFields = filter(fields.value, (_, index) =>
    selectedItems.includes(index),
  );

  const unSelectedFields = filter(
    fields.value,
    (_, index) => !selectedItems.includes(index),
  );

  const notAvailableItems = filter(
    selectedFields,
    (field) => get(field, 'status.name') !== 'Available',
  );

  const availableItems = filter(
    selectedFields,
    (field) => get(field, 'status.name') === 'Available',
  );

  const onRemoveSelectedItems = () => {
    form.change(`itemsData.${holdingsRecordId}`, [
      ...unSelectedFields,
      ...notAvailableItems,
    ]);

    // Pass the indices of deleted items (available items only) to onRemove
    const deletedItemsIndices = selectedItems.filter((index) => {
      const item = fields.value[index];
      return item && get(item, 'status.name') === 'Available';
    });

    onRemove(deletedItemsIndices);
    onClose();
  };

  const renderFooter = () => {
    return (
      <ModalFooter>
        <Button
          id="confirm-delete-holding-modal-btn"
          buttonStyle="primary"
          onClick={() => onRemoveSelectedItems()}
        >
          {!notAvailableItems.length ? (
            <FormattedMessage
              id="ui-plugin-inventory-templates.buttons.deleteItems"
              defaultMessage="Delete items"
            />
          ) : (
            <FormattedMessage
              id="ui-plugin-inventory-templates.buttons.deleteAvailableItems"
              defaultMessage="Continue delete available items"
            />
          )}
        </Button>
        <Button id="confirm-delete-item-modal-cancel-btn" onClick={onClose}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  const FullScreenModal = (
    <div className={open ? css.overlay : ''}>
      <div className={css.overlay_container}>Test full OverlayContainer</div>
    </div>
  );

  const renderModalContent = () => {
    if (notAvailableItems.length) {
      return (
        <>
          <div>
            <FormattedMessage
              id="ui-plugin-inventory-templates.confirmDeleteItemsModal.notAllowDeleteItem.msg1"
              values={{
                itemsCount: <strong>{notAvailableItems.length}</strong>,
                br: <br />,
              }}
              defaultMessage="{itemsCount} items cannot be deleted from the selected list because the item status is unavailable.{br} In order to delete them, the item status must be processed to become available."
            />
          </div>
          <br />
          <MultiColumnList
            contentData={notAvailableItems}
            visibleColumns={[
              'index',
              'barcode',
              'status',
              'materialType',
              'permanentLocation',
            ]}
            columnMapping={{
              index: '#',
              barcode: <FormattedMessage id="ui-inventory.barcode" />,
              status: <FormattedMessage id="ui-inventory.status" />,
              materialType: <FormattedMessage id="ui-inventory.materialType" />,
              permanentLocation: (
                <FormattedMessage id="ui-inventory.itemLocation" />
              ),
            }}
            formatter={{
              index: (item) => item.rowIndex + 1,
              barcode: (item) => (
                <>
                  <ClipCopy text={item.barcode} />
                  {item.barcode}
                </>
              ),
              status: (item) => (
                <FormattedMessage
                  id={getTranslatedItemStatus(item.status.name)}
                  defaultMessage={item.status.name}
                />
              ),
              materialType: (item) => (
                <FormattedMessage
                  id={`ui-inventory.materialTypes.name.${item.materialType.name}`}
                  defaultMessage={item.materialType.name}
                />
              ),
              permanentLocation: (item) => (
                <FormattedMessage
                  id={`ui-tenant-settings.locations.name.${item.permanentLocation.name}`}
                  defaultMessage={item.permanentLocation.name}
                />
              ),
            }}
            columnWidths={{
              index: '5%',
              barcode: '23.75%',
              status: '23.75%',
              materialType: '23.75%',
              permanentLocation: '23.75%',
            }}
          />
          <br />
          <FormattedMessage
            id="ui-plugin-inventory-templates.confirmDeleteItemsModal.notAllowDeleteItem.msg2"
            values={{
              itemsCount: <strong>{availableItems.length}</strong>,
            }}
            defaultMessage="You can continue to delete {itemsCount} items from the available list, as long as the item status is available for them."
          />
        </>
      );
    }

    return (
      <FormattedMessage
        id="ui-plugin-inventory-templates.confirmDeleteItemsModal.deleteItems.msg"
        values={{
          itemCount: <strong>{availableItems.length}</strong>,
        }}
        defaultMessage="Are you sure you want to delete the selected items [{itemCount}]?"
      />
    );
  };

  const ItemsModal = (
    <div className={css.fullscreenModal}>
      <Modal
        id="confirm-delete-items-modal"
        open={open}
        onClose={onClose}
        footer={renderFooter()}
        label={
          <Icon icon="trash" size="large">
            <FormattedMessage
              id="ui-plugin-inventory-templates.confirmDeleteItemsModal.label"
              defaultMessage="Confirm delete multiple items"
            />
          </Icon>
        }
      >
        {renderModalContent()}
      </Modal>
    </div>
  );

  // if (isFullScreen) {
  //   return FullScreenModal;
  // }

  return ItemsModal;

  // const container = document.getElementById('OverlayContainer');
  // return ReactDOM.createPortal(
  //   ItemsModal,
  //   container,
  //   'confirm-delete-items-modal',
  // );
}

ConfirmDeleteItemsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  fields: PropTypes.object,
  holdingsRecordId: PropTypes.string,
  isFullScreen: PropTypes.bool,
  onRemove: PropTypes.func,
};

export default ConfirmDeleteItemsModal;
